<template>
    <div>
         <!-- :label="field.label" -->
        <b-form-group
           
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
            ><label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
            <!-- <label for=""
                >{{ field.label }}<br v-if="field.breakLine" /><span
                    v-if="field.urduLabel"
                    class="urdu-label"
                >
                    ({{ field.urduLabel }})</span
                ></label> -->
            <div v-if="$store.getters.getField('identityInfo.type') == 'id'">
                <masked-input
                    v-model="model"
                    placeholder="Enter ID Document Number"
                    mask="11111-1111111-1"
                    class="form-control"
                    :disabled="true"
                    @blur.native="onBlur"
                />
                <!-- @input="isPmdaFormValid" -->
            </div>
            <div v-else>
                <b-form-input
                    v-model="model"
                    v-validate="{
                        required: field.isRequired,
                        email: !!field.isEmail,
                        numeric: setIsNumeric,
                        max: setMaxLength,
                        min: setMinLength,
                        alpha_num: field.isAlphaNum ? field.isAlphaNum : false,
                        alpha_spaces: field.isAlpha ? field.isAlpha : false,
                    }"
                    type="text"
                    autocomplete="no"
                    :placeholder="field.placeholder"
                    :disabled="loading || isDisable"
                    :data-vv-name="field.label"
                    :maxlength="setMaxLength"
                    :class="{
                        'is-invalid': errors.has(field.label),
                    }"
                    @blur="onBlur"
                ></b-form-input>
            </div>
        </b-form-group>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MaskedInput from 'vue-masked-input'
export default {
    /*
|--------------------------------------------------------------------------
| Component > inject
|--------------------------------------------------------------------------
*/
    inject: {
        $validator: '$validator',
    }, // End of Component > inject
    /*
|--------------------------------------------------------------------------
| Component > components
|--------------------------------------------------------------------------
*/
    components: {
        MaskedInput,
    }, // End of Component > components
    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props
    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data() {
        this.setMinLength = this.field.minLength
        this.setMaxLength = this.field.maxLength
        if (this.field.isNumeric) {
            if (this.field.key === 'identityInfo.number') {
                let idType =
                    this.$store.state.registration.form.identityInfo.type
                if (idType === 'passport') {
                    this.setNumeric = 'text'
                    this.setIsNumeric = false
                    this.setMinLength = 9
                    this.setMaxLength = 9
                } else {
                    //console.log('number sent')
                    this.setNumeric = 'number'
                    this.setIsNumeric = true
                }
            } else {
                this.setNumeric = 'number'
                this.setIsNumeric = true
            }
        } else {
            this.setNumeric = 'text'
            this.setIsNumeric = false
        }
        return {
            value: '',
            isDisable: true,
            rawVal: '',
        }
    }, // End of Component > data
    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapGetters(['loading']),
        urduLabel(){
            if(this.$store.state.registration.form.languageOption == 'urd'){
                return true
            } else {
                return false
            }
        },
        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
    }, // End of Component > methods
    /*
  |--------------------------------------------------------------------------
  | Component > Created
  |--------------------------------------------------------------------------
  */
    created() {
        if (this.field.key === 'accountInfo.nomineeCNIC1') {
            const applyNomineeCnic = (addNominee) => {
                if (addNominee === 'Yes') {
                    this.field.isRequired = true
                    this.isDisable = false
                } else {
                    this.field.isRequired = false
                    this.isDisable = true
                    this.writeValue('')
                }
            }
            applyNomineeCnic(
                this.$store.state.registration.form.accountInfo.addNominee
            )
            this.$store.watch(
                (state) => state.registration.form.accountInfo.addNominee,
                applyNomineeCnic
            )
        }
        /*
    | -------------------------------------------
    | NTN is equal to IDENTITY NUMBER
    | -------------------------------------------
    */
        // if (this.field.key == 'identityInfo.number') {
        //     this.$store.watch(
        //         (state) => {
        //             return this.$store.state.registration.form.identityInfo
        //                 .number // could also put a Getter here
        //         },
        //         (newValue, oldValue) => {
        //             // console.log('Identity Number : ' + newValue)
        //             if (newValue) {
        //                 let str = newValue.replace(/-/g, '')
        //                 this.$store.commit('updateField', {
        //                     key: 'occupationInfo.taxNo',
        //                     value: str,
        //                 })
        //             }
        //         }
        //     )
        // } // End
    }, // End Component > Created
    mounted() {}, // End of Component > computed
    /*
|--------------------------------------------------------------------------
| Component > methods
|--------------------------------------------------------------------------
*/
    methods: {
        writeValue(newValue) {
            this.value = newValue
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue,
                })
            } else {
                this.$store.commit('updateField', {
                    key: `customInfo.${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: newValue,
                    },
                })
            }
        },
        isPmdaFormValid() {
            // this.rawVal = arguments[1]
            // console.log('this.isPmdaFormValid')
            this.$store.commit('updateField', {
                key: 'pmdaForm.valid',
                value: false,
            })
        },

        onBlur(event) {
            let value = event.target.value
            // console.log('evt', event.target.value)
            this.$emit('onBlur', value)
        },
    }, // End of Component > mounted
}
</script>
